import {
  AiListingAddPhotosEvent,
  AiListingDescriptionEvent,
  AiListingFieldEditEvent,
  AiListingFormSubmitEvent,
  AiListingLeaveConfirmationEvent,
  AiListingPhotoReorderEvent,
  AiListingScanEvent,
  AiListingStartEvent,
} from '@interfaces/models/internal/analytics-event/ai-listing-event';

export const aiListingStartEventPayload: Omit<AiListingStartEvent, 'action'> = {
  event: 'ai_listing',
  category: 'listing_start',
};

export const aiListingScanEventPayload: AiListingScanEvent = {
  event: 'ai_listing',
  category: 'ai_listing',
  action: 'ai_scanning',
};

export const aiListingAddPhotosEventPayload: AiListingAddPhotosEvent = {
  event: 'ai_listing',
  category: 'ai_listing',
  action: 'add_photos',
  label: 'photo_step',
};

export const aiListingPhotoReorderEventPayload: Omit<AiListingPhotoReorderEvent, 'label' | 'value'> = {
  event: 'ai_listing',
  category: 'ai_listing',
  action: 'photo_reorder',
};

export const aiListingLeaveConfirmationEventPayload: Omit<AiListingLeaveConfirmationEvent, 'action' | 'label'> = {
  event: 'ai_listing',
  category: 'ai_listing',
};

export const aiListingFieldEditEventPayload: Omit<AiListingFieldEditEvent, 'action' | 'label'> = {
  event: 'ai_listing',
  category: 'ai_listing',
};

export const aiListingDescriptionEventPayload: Omit<AiListingDescriptionEvent, 'label'> = {
  event: 'ai_listing',
  category: 'ai_listing',
  action: 'description',
};

export const aiListingFormSubmitEventPayload: Omit<AiListingFormSubmitEvent, 'action'> = {
  event: 'ai_listing',
  category: 'ai_listing',
};
